export default __webpack_public_path__ + "static/media/ic-MRP-fill-bg.7c830458.svg";